<template>
  <div style="margin: 25px 0; display: flex; justify-content: space-between">
    <div class="card-container">
      <a-tabs type="card">
        <a-tab-pane key="/techCol" tab="校园文化">
          <router-link
            :to="{ path: '/techCol', query: { name: '校园文化' } }"
            class="btn"
            tag="div"
          >
            更多
            <a-icon type="right" />
          </router-link>
          <div
            style="display: flex; justify-content: space-between; height: 280px"
          >
            <div style="width: 40%">
              <div class="imgLoopInner">
                <img :src="bigImg2" alt />
                <div>{{ newsTitle2 }}</div>
              </div>
            </div>
            <div
              :style="
                bigImg2 == null || bigImg2 == ''
                  ? 'width: 100%; height: 280px; overflow: hidden'
                  : 'width: 60%; height: 280px; overflow: hidden'
              "
            >
            <div v-for="(item, index) in curList"
                :key="index">
                <a v-if="item.urlAddress && item.urlAddress!=''" :href="item.urlAddress" tag="div"
      class="botDyRightBox">
      <div
                  class="botDyRight"
                  v-show="
                    item.picUrl == null || item.picUrl == ''
                      ? (isImg = false)
                      : (isImg = true)
                  "
                >
                  <img :src="item.picUrl" alt />
                </div>
                <div>
                  <div>{{ item.newsTitle }}</div>
                  <div>{{ item.sNewsTitle }}</div>
                </div>
      </a>
            <router-link v-else
                :to="{
                  path: '/tabDetails',
                  query: {
                    newsId: item.newsId,
                    navText: '校园文化',
                    title: item.newsTitle,
                    newsTitle: item.newsTitle,
                    source: item.source,
                    createBy: item.createBy,
                    newsTitle: item.newsTitle,
                    urlAddress: item.urlAddress,
                  },
                }"
                class="botDyRightBox"
                
                tag="div"
              >
                <div
                  class="botDyRight"
                  v-show="
                    item.picUrl == null || item.picUrl == ''
                      ? (isImg = false)
                      : (isImg = true)
                  "
                >
                  <img :src="item.picUrl" alt />
                </div>
                <div>
                  <div>{{ item.newsTitle }}</div>
                  <div>{{ item.sNewsTitle }}</div>
                </div>
              </router-link>
          </div>
              
            </div>
          </div>
        </a-tab-pane>
        <a-tab-pane key="/scTeam" tab="校企合作">
          <router-link
            :to="{ path: '/scTeam', query: { name: '校企合作' } }"
            class="btn"
            tag="div"
          >
            更多
            <a-icon type="right" />
          </router-link>
          <div
            style="display: flex; justify-content: space-between; height: 280px"
          >
            <div
              style="width: 40%"
              v-show="
                bigImg3 == null || bigImg3 == ''
                  ? (isImg = false)
                  : (isImg = true)
              "
            >
              <div class="imgLoopInner">
                <img :src="bigImg3" alt />
                <div>{{ newsTitle3 }}</div>
              </div>
            </div>
            <div
              :style="
                bigImg3 == null || bigImg3 == ''
                  ? 'width: 100%; height: 280px; overflow: hidden'
                  : 'width: 60%; height: 280px; overflow: hidden'
              "
            >
            <div v-for="(item, index) in teamList"
                :key="index">
                <a v-if="item.urlAddress && item.urlAddress!=''" :href="item.urlAddress" tag="div"
      class="botDyRightBox">
      <div
                  class="botDyRight"
                  v-show="
                    item.picUrl == null || item.picUrl == ''
                      ? (isImg = false)
                      : (isImg = true)
                  "
                >
                  <img :src="item.picUrl" alt />
                </div>
                <div>
                  <div>{{ item.newsTitle }}</div>
                  <div>{{ item.sNewsTitle }}</div>
                </div>
      </a>
            <router-link v-else
                :to="{
                  path: '/tabDetails',
                  query: {
                    newsId: item.newsId,
                    navText: '校企合作',
                    title: item.newsTitle,
                    newsTitle: item.newsTitle,
                    source: item.source,
                    createBy: item.createBy,
                    newsTitle: item.newsTitle,
                    urlAddress: item.urlAddress,
                  },
                }"
                class="botDyRightBox"
                
                tag="div"
              >
                <div
                  class="botDyRight"
                  v-show="
                    item.picUrl == null || item.picUrl == ''
                      ? (isImg = false)
                      : (isImg = true)
                  "
                >
                  <img :src="item.picUrl" alt />
                </div>
                <div>
                  <div>{{ item.newsTitle }}</div>
                  <div>{{ item.sNewsTitle }}</div>
                </div>
              </router-link>
          </div>
              
            </div>
          </div>
        </a-tab-pane>
        <a-tab-pane key="/empExis" tab="就业信息">
          <router-link
            :to="{ path: '/empExis', query: { name: '就业信息' } }"
            class="btn"
            tag="div"
          >
            更多
            <a-icon type="right" />
          </router-link>
          <div
            :style="
              bigImg4 == null || bigImg4 == ''
                ? 'width: 100%; height: 280px; overflow: hidden'
                : 'width: 60%; height: 280px; overflow: hidden'
            "
          >
          <div v-for="(item, index) in jiuList"
              :key="index">
              <a v-if="item.urlAddress && item.urlAddress!=''" :href="item.urlAddress" tag="div"
      class="botDyRightBox">
      <div
                class="botDyRight"
                v-show="
                  item.picUrl == null || item.picUrl == ''
                    ? (isImg = false)
                    : (isImg = true)
                "
              >
                <img :src="item.picUrl" alt />
              </div>
              <div>
                <div>{{ item.newsTitle }}</div>
                <div>{{ item.sNewsTitle }}</div>
              </div>
      </a>
            <router-link v-else
              :to="{
                path: '/tabDetails',
                query: {
                  newsId: item.newsId,
                  navText: '就业信息',
                  title: item.newsTitle,
                  newsTitle: item.newsTitle,
                  source: item.source,
                  createBy: item.createBy,
                  newsTitle: item.newsTitle,
                  urlAddress: item.urlAddress,
                },
              }"
              class="botDyRightBox"
              
              tag="div"
            >
              <div
                class="botDyRight"
                v-show="
                  item.picUrl == null || item.picUrl == ''
                    ? (isImg = false)
                    : (isImg = true)
                "
              >
                <img :src="item.picUrl" alt />
              </div>
              <div>
                <div>{{ item.newsTitle }}</div>
                <div>{{ item.sNewsTitle }}</div>
              </div>
            </router-link>
          </div>
            
          </div>
        </a-tab-pane>
        <a-tab-pane key="/techPrj" tab="实习培训">
          <router-link
            :to="{ path: '/techPrj', query: { name: '实习培训' } }"
            class="btn"
            tag="div"
          >
            更多
            <a-icon type="right" />
          </router-link>
          <div
            style="display: flex; justify-content: space-between; height: 280px"
          >
            <div style="width: 40%">
              <div class="imgLoopInner">
                <img :src="bigImg5" alt />
                <div>{{ newsTitle5 }}</div>
              </div>
            </div>
            <div
              :style="
                bigImg5 == null || bigImg5 == ''
                  ? 'width: 100%; height: 280px; overflow: hidden'
                  : 'width: 60%; height: 280px; overflow: hidden'
              "
            >
            <div v-for="(item, index) in peiList"
                :key="index">
                <a v-if="item.urlAddress && item.urlAddress!=''" :href="item.urlAddress" tag="div"
      class="botDyRightBox">
      <div
                  class="botDyRight"
                  v-show="
                    item.picUrl == null || item.picUrl == ''
                      ? (isImg = false)
                      : (isImg = true)
                  "
                >
                  <img :src="item.picUrl" alt />
                </div>
                <div>
                  <div>{{ item.newsTitle }}</div>
                  <div>{{ item.sNewsTitle }}</div>
                </div>
      </a>
             <router-link
                :to="{
                  path: '/tabDetails',
                  query: {
                    newsId: item.newsId,
                    navText: '实习培训',
                    title: item.newsTitle,
                    newsTitle: item.newsTitle,
                    source: item.source,
                    createBy: item.createBy,
                    newsTitle: item.newsTitle,
                    urlAddress: item.urlAddress,
                  },
                }"
                class="botDyRightBox"
                
                tag="div"
              >
                <div
                  class="botDyRight"
                  v-show="
                    item.picUrl == null || item.picUrl == ''
                      ? (isImg = false)
                      : (isImg = true)
                  "
                >
                  <img :src="item.picUrl" alt />
                </div>
                <div>
                  <div>{{ item.newsTitle }}</div>
                  <div>{{ item.sNewsTitle }}</div>
                </div>
              </router-link>
          </div>
             
            </div>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
    <div class="botDyLoopRight">
      <router-link
        :to="{ path: '/zhaosheng', query: { name: '招生信息' } }"
        tag="div"
        class="hoverCol"
      >
        <img
          src="../../../../static/img/index/pei16.jpg"
          style="width: 80%"
          alt
        />
        <div>招生简章</div>
      </router-link>
    </div>
  </div>
</template>
<script>
import { postNewsByPage } from "../../../api/api";
export default {
  data() {
    return {
      curList: [],
      teamList: [],
      jiuList: [],
      peiList: [],
      bigImg2: "",
      bigImg3: "",
      bigImg4: "",
      bigImg5: "",
      newsTitle2: "",
      newsTitle3: "",
      newsTitle4: "",
      newsTitle5: "",
      isImg: false,
      routePath: "/tabDetails",
      name: "校园文化",
      emptyImg: "",
    };
  },
  created() {
    postNewsByPage(17961944805582, 1, 4).then((res) => {
      // //console.log(res);
      this.curList = res.list;
      this.bigImg2 = res.list[3].picUrl;
      this.newsTitle2 = res.list[3].newsTitle;
    });
    postNewsByPage(16958298329334, 1, 4).then((res) => {
      // //console.log(res);
      this.teamList = res.list;
      this.bigImg3 = res.list[3].picUrl;
      this.newsTitle3 = res.list[3].newsTitle;
    });
    postNewsByPage(26051788345765, 1, 4).then((res) => {
      // //console.log(res);
      this.jiuList = res.list;
      this.bigImg4 = res.list[3].picUrl;
      this.newsTitle4 = res.list[3].newsTitle;
    });
    postNewsByPage(17378367429907, 1, 4).then((res) => {
      // //console.log(res);
      this.peiList = res.list;
      this.bigImg5 = res.list[3].picUrl;
      this.newsTitle5 = res.list[3].newsTitle;
    });
  },
};
</script>
<style scoped>
.card-container {
  overflow: hidden;
  box-shadow: 0px 0px 20px 0px rgba(0, 91, 176, 0.1);
  width: 70%;
  margin-left: 6px;
  position: relative;
}
div /deep/ .titleMore {
  position: absolute;
  top: 7%;
  border-radius: 10px;
  right: 18px;
  z-index: 1;
  font-size: 12px;
  background: #35b391 !important;
  border-color: #35b391;
}
.ant-btn > .anticon + span,
.ant-btn > span + .anticon {
  margin-left: 0px !important;
}
.card-container > .ant-tabs-card > .ant-tabs-content {
  height: 120px;
}

.card-container > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
  background: #fff;
  padding: 16px;
}
.btn {
  position: absolute;
  top: 8%;
  right: 4%;
  background: #35b391;
  color: #fff;
  padding: 3px 5px;
  border-radius: 11px;
}
.btn:hover {
  cursor: pointer;
}
div /deep/.card-container > .ant-tabs-card > .ant-tabs-bar {
  border-color: #fff;
  background-image: url("../../../../static/img/index/xyCre.jpg");
  background-size: 100% 100%;
  margin: 0;
  padding: 30px;
  padding-bottom: 0;
}
div /deep/ .ant-tabs-tab {
  background: none !important;
  border: none !important;
  color: #fff !important;
  font-weight: bold;
}
div /deep/ .ant-tabs-tab-active {
  background: #fff !important;
  border-color: #e8e8e8 !important;
  border-bottom: 1px solid #fff !important;
  color: #35b391 !important;
  font-weight: bold;
}
.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
  border-color: transparent;
  background: lightblue;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
  border-color: #fff;
  background: #fff;
}

.tabInner {
  display: flex;
  justify-content: space-between;
  color: #8c898d;
  line-height: 50px;
}
.tabInner:hover {
  color: #2280b0;
  cursor: pointer;
}
.tabInner > div:nth-of-type(1) {
  width: 85%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
.imgLoopInner {
  position: relative;
  width: 100%;
  height: 100%;
}
.imgLoopInner > div {
  position: absolute;
  bottom: 0;
  height: 30px;
  line-height: 30px;
  width: 100%;
  text-align: center;
  color: #fff;
  background: rgba(31, 45, 61, 0.4);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
.botDyRightBox {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 5px;
  background-color: #f8f8fa;
  color: #333;
  height: 90px;
  padding: 18px;
  position: relative;
}
.botDyRightBox:hover {
  background-color: #2280b0;
  color: #fff;
  cursor: pointer;
}
.botDyRightBox:nth-last-of-type(1) {
  margin-bottom: 0;
}
.imgLoopInner > img {
  width: 100%;
  height: 100%;
}
.botDyRight {
  width: 20%;
  height: 65px;
}
.botDyRightBox > div:nth-of-type(2) {
  width: 78%;
  padding: 5px;
}
.botDyRight > img {
  width: 100%;
  height: 100%;
}
.botDyRightBox > div:nth-of-type(2) > div:nth-of-type(1) {
  color: #333;
  font-weight: bold;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
.botDyRightBox > div:nth-of-type(2) > div:nth-of-type(2) {
  color: #c5c5c7;
  font-size: 12px;
  margin-top: 0px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.botDyTime {
  position: absolute;
  bottom: 2%;
  right: 2%;
  color: #c5c5c7;
  font-size: 12px;
}
.botDyLoopRight {
  width: 25%;
  margin-right: 6px;
  box-shadow: 0px 0px 20px 0px rgba(0, 91, 176, 0.1);
  padding: 10px 30px;
  text-align: center;
}
.botDyLoopRight > div > div {
  color: #333;
  font-weight: bold;
  padding: 10px 0;
}
.hoverCol > div:hover,
.hoverCol:hover {
  cursor: pointer;
  color: #2280b0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/indexComp/smallComp/botDynamic.vue